module.exports = __webpack_public_path__ + "static/media/sidebar-schedule-selected.bd0c6f08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-schedule-selected.svg
// module id = 802
// module chunks = 0